import { getItem } from "./LocalStorage";

export const CURRENCY_SYMBOLS = { EUR: "€", USD: "$", GBP: "£", INR: "₹" };
export const CURRENCY_OPTIONS = Object.keys(CURRENCY_SYMBOLS);

export const getCurrencySymbol = (code) =>
  CURRENCY_SYMBOLS[code] || CURRENCY_SYMBOLS.EUR;

export const getCurrencyCode = (user) =>
  user?.settings?.currency || getItem("currency") || "EUR";

const CURRENCY_ICONS = {
  EUR: "fa-euro-sign",
  USD: "fa-dollar-sign",
  GBP: "fa-pound-sign",
  INR: "fa-rupee-sign",
};

export const getCurrencyIcon = (code) =>
  CURRENCY_ICONS[code] || CURRENCY_ICONS.EUR;
